import { render, staticRenderFns } from "./RelationManage.vue?vue&type=template&id=e3c05828&scoped=true&"
import script from "./RelationManage.vue?vue&type=script&lang=js&"
export * from "./RelationManage.vue?vue&type=script&lang=js&"
import style0 from "./RelationManage.vue?vue&type=style&index=0&id=e3c05828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c05828",
  null
  
)

export default component.exports